import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "row animated fadeIn" }
const _hoisted_2 = { class: "col-xl-12 col-lg-12" }
const _hoisted_3 = { class: "card shadow mb-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "card-header py-3 d-flex flex-row align-items-center justify-content-start" }, [
  /*#__PURE__*/_createVNode("h6", { class: "m-0 font-weight-bold" }, " Manage Bank & Wallets Accounts "),
  /*#__PURE__*/_createVNode("small", { class: "ml-2" }, "Please validate user accounts.")
], -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Add Bank or Wallet ")
const _hoisted_12 = { class: "col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "text-muted text-left" }, " Please select an account. ", -1)
const _hoisted_15 = {
  key: 1,
  class: "row"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "col-12 text-left" }, [
  /*#__PURE__*/_createVNode("h5", null, "Receiving Bank Information")
], -1)
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "form-group text-left" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", { for: "currencyId" }, " Currency:* ", -1)
const _hoisted_20 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_21 = { class: "form-group text-left" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { for: "recipientFullName" }, " Recipient Full Name:* ", -1)
const _hoisted_23 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_24 = { class: "form-group text-left" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { for: "bankName" }, " Bank Name:* ", -1)
const _hoisted_26 = { class: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" }
const _hoisted_27 = { class: "form-group text-left" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { for: "bankAddress" }, " Bank Address:* ", -1)
const _hoisted_29 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_30 = { class: "form-group text-left" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", { for: "bankAccountNumber" }, " Bank Account Number:* ", -1)
const _hoisted_32 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_33 = { class: "form-group text-left" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { for: "postalCode" }, " Postal Code:* ", -1)
const _hoisted_35 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_36 = { class: "form-group text-left" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", { for: "city" }, " City:* ", -1)
const _hoisted_38 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_39 = { class: "form-group text-left" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { for: "province" }, " Province:* ", -1)
const _hoisted_41 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_42 = { class: "form-group text-left" }
const _hoisted_43 = /*#__PURE__*/_createVNode("label", { for: "country" }, " Country:* ", -1)
const _hoisted_44 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_45 = { class: "form-group text-left" }
const _hoisted_46 = /*#__PURE__*/_createVNode("label", { for: "swiftOrBic" }, " SWIFT/BIC:* ", -1)
const _hoisted_47 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_48 = { class: "form-group text-left" }
const _hoisted_49 = /*#__PURE__*/_createVNode("label", { for: "transitNumber" }, " Transit Number:* ", -1)
const _hoisted_50 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_51 = { class: "form-group text-left" }
const _hoisted_52 = /*#__PURE__*/_createVNode("label", { for: "institutionNumber" }, " Institution Number:* ", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "col-12 text-left" }, [
  /*#__PURE__*/_createVNode("h5", null, "Account Holder Information")
], -1)
const _hoisted_54 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_55 = { class: "form-group text-left" }
const _hoisted_56 = /*#__PURE__*/_createVNode("label", { for: "accountName" }, " Account Name:* ", -1)
const _hoisted_57 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_58 = { class: "form-group text-left" }
const _hoisted_59 = /*#__PURE__*/_createVNode("label", { for: "phoneNumber" }, " Phone Number:* ", -1)
const _hoisted_60 = { class: "col-12" }
const _hoisted_61 = { class: "form-group text-left" }
const _hoisted_62 = /*#__PURE__*/_createVNode("label", { for: "legalAddressAccountHolder" }, " Legal Address of Account Holder:* ", -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("small", null, " Full Address, City, Province, Postal Code. ", -1)
const _hoisted_64 = { class: "col-12" }
const _hoisted_65 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Validate FIAT Account ")
const _hoisted_67 = {
  key: 2,
  class: "row"
}
const _hoisted_68 = { class: "col-12" }
const _hoisted_69 = { class: "form-group text-left" }
const _hoisted_70 = /*#__PURE__*/_createVNode("label", { for: "currencyId" }, " Currency:* ", -1)
const _hoisted_71 = { class: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" }
const _hoisted_72 = { class: "form-group text-left" }
const _hoisted_73 = /*#__PURE__*/_createVNode("label", { for: "cryptoAddress" }, " Crypto Address:* ", -1)
const _hoisted_74 = { class: "col-12" }
const _hoisted_75 = { class: "form-group text-left" }
const _hoisted_76 = /*#__PURE__*/_createVNode("label", { for: "accountName" }, " Account Name:* ", -1)
const _hoisted_77 = { class: "col-12" }
const _hoisted_78 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" Validate CRYPTO Account ")
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "col-12" }
const _hoisted_82 = { class: "form-group text-left" }
const _hoisted_83 = /*#__PURE__*/_createVNode("label", { for: "amount" }, " *Select Your Account Type: ", -1)
const _hoisted_84 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_85 = { class: "form-check form-check-inline" }
const _hoisted_86 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "isCrypto1"
}, "Fiat", -1)
const _hoisted_87 = { class: "form-check form-check-inline" }
const _hoisted_88 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "isCrypto2"
}, "Crypto", -1)
const _hoisted_89 = {
  key: 0,
  class: "row"
}
const _hoisted_90 = /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createVNode("h5", null, "Receiving Bank Information")
], -1)
const _hoisted_91 = { class: "col-12" }
const _hoisted_92 = { class: "form-group text-left" }
const _hoisted_93 = /*#__PURE__*/_createVNode("label", { for: "currencyId" }, " Currency:* ", -1)
const _hoisted_94 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_95 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_96 = { class: "form-group text-left" }
const _hoisted_97 = /*#__PURE__*/_createVNode("label", { for: "recipientFullName" }, " Recipient Full Name:* ", -1)
const _hoisted_98 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_99 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_100 = { class: "form-group text-left" }
const _hoisted_101 = /*#__PURE__*/_createVNode("label", { for: "bankName" }, " Bank Name:* ", -1)
const _hoisted_102 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_103 = { class: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" }
const _hoisted_104 = { class: "form-group text-left" }
const _hoisted_105 = /*#__PURE__*/_createVNode("label", { for: "bankAddress" }, " Bank Address:* ", -1)
const _hoisted_106 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_107 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_108 = { class: "form-group text-left" }
const _hoisted_109 = /*#__PURE__*/_createVNode("label", { for: "bankAccountNumber" }, " Bank Account Number:* ", -1)
const _hoisted_110 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_111 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_112 = { class: "form-group text-left" }
const _hoisted_113 = /*#__PURE__*/_createVNode("label", { for: "postalCode" }, " Postal Code:* ", -1)
const _hoisted_114 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_115 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_116 = { class: "form-group text-left" }
const _hoisted_117 = /*#__PURE__*/_createVNode("label", { for: "city" }, " City:* ", -1)
const _hoisted_118 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_119 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_120 = { class: "form-group text-left" }
const _hoisted_121 = /*#__PURE__*/_createVNode("label", { for: "province" }, " Province:* ", -1)
const _hoisted_122 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_123 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_124 = { class: "form-group text-left" }
const _hoisted_125 = /*#__PURE__*/_createVNode("label", { for: "country" }, " County:* ", -1)
const _hoisted_126 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_127 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_128 = { class: "form-group text-left" }
const _hoisted_129 = /*#__PURE__*/_createVNode("label", { for: "swiftOrBic" }, " SWIFT/BIC:* ", -1)
const _hoisted_130 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_131 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_132 = { class: "form-group text-left" }
const _hoisted_133 = /*#__PURE__*/_createVNode("label", { for: "transitNumber" }, " Transit Number:* ", -1)
const _hoisted_134 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_135 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_136 = { class: "form-group text-left" }
const _hoisted_137 = /*#__PURE__*/_createVNode("label", { for: "institutionNumber" }, " Institution Number:* ", -1)
const _hoisted_138 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_139 = /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createVNode("h5", null, "Account Holder Information")
], -1)
const _hoisted_140 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_141 = { class: "form-group text-left" }
const _hoisted_142 = /*#__PURE__*/_createVNode("label", { for: "accountName" }, " Account Name:* ", -1)
const _hoisted_143 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_144 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_145 = { class: "form-group text-left" }
const _hoisted_146 = /*#__PURE__*/_createVNode("label", { for: "phoneNumber" }, " Phone Number:* ", -1)
const _hoisted_147 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_148 = { class: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" }
const _hoisted_149 = { class: "form-group text-left" }
const _hoisted_150 = /*#__PURE__*/_createVNode("label", { for: "legalAddressAccountHolder" }, " Legal Address of Account Holder:* ", -1)
const _hoisted_151 = /*#__PURE__*/_createVNode("small", null, " Full Address, City, Province, Postal Code. ", -1)
const _hoisted_152 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_153 = {
  key: 1,
  class: "row"
}
const _hoisted_154 = { class: "col-12" }
const _hoisted_155 = { class: "form-group text-left" }
const _hoisted_156 = /*#__PURE__*/_createVNode("label", { for: "currencyId" }, " Currency:* ", -1)
const _hoisted_157 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_158 = { class: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" }
const _hoisted_159 = { class: "form-group text-left" }
const _hoisted_160 = /*#__PURE__*/_createVNode("label", { for: "cryptoAddress" }, " Crypto Address:* ", -1)
const _hoisted_161 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_162 = { class: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" }
const _hoisted_163 = { class: "form-group text-left" }
const _hoisted_164 = /*#__PURE__*/_createVNode("label", { for: "accountName" }, " Account Name:* ", -1)
const _hoisted_165 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_166 = { class: "row" }
const _hoisted_167 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")
  const _component_csrf_token = _resolveComponent("csrf-token")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_Listbox, {
                  modelValue: _ctx.selectedAccount,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedAccount = $event)),
                  options: _ctx.userAccounts,
                  filter: true,
                  optionLabel: "label",
                  listStyle: "max-height:500px;",
                  filterPlaceholder: "Search"
                }, {
                  option: _withCtx((slotProps) => [
                    _createVNode("div", null, [
                      _createVNode("div", null, _toDisplayString(slotProps.option.label), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"]),
                _createVNode("div", _hoisted_9, [
                  _createVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addAccount && _ctx.addAccount(...args))),
                    class: "btn btn-block btn-sm btn-sky"
                  }, [
                    _hoisted_10,
                    _hoisted_11
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_12, [
                (!_ctx.selectedAccount || !_ctx.selectedAccount.type)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _hoisted_14
                    ]))
                  : (_ctx.selectedAccount.type === 1)
                    ? (_openBlock(), _createBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode("div", _hoisted_17, [
                          _createVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              disabled: true,
                              id: "currencyId",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedAccount.currencyId = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.selectedAccount.currencyId]
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_20, [
                          _createVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              disabled: true,
                              id: "recipientFullName",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedAccount.recipientFullName = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.selectedAccount.recipientFullName]
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_23, [
                          _createVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              id: "bankName",
                              class: "form-control",
                              disabled: true,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedAccount.bankName = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.selectedAccount.bankName]
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_26, [
                          _createVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              id: "bankAddress",
                              class: "form-control",
                              disabled: true,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedAccount.bankAddress = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.selectedAccount.bankAddress]
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_29, [
                          _createVNode("div", _hoisted_30, [
                            _hoisted_31,
                            _createVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "bankAccountNumber",
                              disabled: true,
                              value: 
                          _ctx.formatBankNumber(_ctx.selectedAccount.bankAccountNumber)
                        
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_32, [
                          _createVNode("div", _hoisted_33, [
                            _hoisted_34,
                            _createVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "postalCode",
                              disabled: true,
                              value: _ctx.selectedAccount.postalCode
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_35, [
                          _createVNode("div", _hoisted_36, [
                            _hoisted_37,
                            _createVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "city",
                              disabled: true,
                              value: _ctx.selectedAccount.city
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_38, [
                          _createVNode("div", _hoisted_39, [
                            _hoisted_40,
                            _createVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "province",
                              disabled: true,
                              value: _ctx.selectedAccount.province
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_41, [
                          _createVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _createVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "country",
                              disabled: true,
                              value: _ctx.selectedAccount.country
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_44, [
                          _createVNode("div", _hoisted_45, [
                            _hoisted_46,
                            _createVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "swiftOrBic",
                              disabled: true,
                              value: _ctx.selectedAccount.swiftOrBic
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_47, [
                          _createVNode("div", _hoisted_48, [
                            _hoisted_49,
                            _createVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "transitNumber",
                              disabled: true,
                              value: _ctx.selectedAccount.transitNumber
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_50, [
                          _createVNode("div", _hoisted_51, [
                            _hoisted_52,
                            _createVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "institutionNumber",
                              disabled: true,
                              value: _ctx.selectedAccount.institutionNumber
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _hoisted_53,
                        _createVNode("div", _hoisted_54, [
                          _createVNode("div", _hoisted_55, [
                            _hoisted_56,
                            _createVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "accountName",
                              disabled: true,
                              value: _ctx.selectedAccount.accountName
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_57, [
                          _createVNode("div", _hoisted_58, [
                            _hoisted_59,
                            _createVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "phoneNumber",
                              disabled: true,
                              value: _ctx.selectedAccount.phoneNumber
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_60, [
                          _createVNode("div", _hoisted_61, [
                            _hoisted_62,
                            _withDirectives(_createVNode("input", {
                              disabled: "",
                              type: "text",
                              class: "form-control",
                              id: "legalAddressAccountHolder",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedAccount.legalAddressAccountHolder = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.selectedAccount.legalAddressAccountHolder]
                            ]),
                            _hoisted_63
                          ])
                        ]),
                        _createVNode("div", _hoisted_64, [
                          _createVNode("button", {
                            class: "btn btn-success",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.validateAccount($event))),
                            disabled: _ctx.selectedAccount.isActive
                          }, [
                            _hoisted_65,
                            _hoisted_66
                          ], 8, ["disabled"])
                        ])
                      ]))
                    : (_ctx.selectedAccount.type === 2)
                      ? (_openBlock(), _createBlock("div", _hoisted_67, [
                          _createVNode("div", _hoisted_68, [
                            _createVNode("div", _hoisted_69, [
                              _hoisted_70,
                              _withDirectives(_createVNode("input", {
                                disabled: true,
                                type: "text",
                                class: "form-control",
                                id: "currencyId",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectedAccount.currencyId = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.selectedAccount.currencyId]
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_71, [
                            _createVNode("div", _hoisted_72, [
                              _hoisted_73,
                              _createVNode("input", {
                                disabled: true,
                                type: "text",
                                class: "form-control",
                                id: "cryptoAddress",
                                value: 
                          _ctx.formatCryptoAddress(_ctx.selectedAccount.cryptoAddress)
                        
                              }, null, 8, ["value"])
                            ])
                          ]),
                          _createVNode("div", _hoisted_74, [
                            _createVNode("div", _hoisted_75, [
                              _hoisted_76,
                              _withDirectives(_createVNode("input", {
                                disabled: true,
                                type: "text",
                                class: "form-control",
                                id: "accountName",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedAccount.accountName = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.selectedAccount.accountName]
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_77, [
                            _createVNode("button", {
                              class: "btn btn-success",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validateAccount($event))),
                              disabled: _ctx.selectedAccount.isActive
                            }, [
                              _hoisted_78,
                              _hoisted_79
                            ], 8, ["disabled"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
              ]),
              _createVNode(_component_ConfirmPopup)
            ])
          ])
        ]),
        _createVNode(_component_Dialog, {
          header: "Add Bank or Wallet",
          visible: _ctx.showModal,
          "onUpdate:visible": _cache[33] || (_cache[33] = ($event: any) => (_ctx.showModal = $event)),
          style: { width: '50vw' },
          modal: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_csrf_token),
            _createVNode("div", _hoisted_80, [
              _createVNode("div", _hoisted_81, [
                _createVNode("div", _hoisted_82, [
                  _hoisted_83,
                  _hoisted_84,
                  _createVNode("div", _hoisted_85, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.isCrypto = $event)),
                      value: false,
                      id: "isCrypto1",
                      type: "radio"
                    }, null, 512), [
                      [_vModelRadio, _ctx.isCrypto]
                    ]),
                    _hoisted_86
                  ]),
                  _createVNode("div", _hoisted_87, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.isCrypto = $event)),
                      id: "isCrypto2",
                      value: true,
                      type: "radio"
                    }, null, 512), [
                      [_vModelRadio, _ctx.isCrypto]
                    ]),
                    _hoisted_88
                  ])
                ])
              ])
            ]),
            (!_ctx.isCrypto)
              ? (_openBlock(), _createBlock("div", _hoisted_89, [
                  _hoisted_90,
                  _createVNode("div", _hoisted_91, [
                    _createVNode("div", _hoisted_92, [
                      _hoisted_93,
                      _withDirectives(_createVNode("select", {
                        id: "currencyId",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.bankForm.props.currencyId = $event))
                      }, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fiatsAssets, (c) => {
                          return (_openBlock(), _createBlock("option", {
                            key: c.id,
                            value: c.id
                          }, _toDisplayString(c.id) + " " + _toDisplayString(c.description), 9, ["value"]))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.bankForm.props.currencyId]
                      ]),
                      (_ctx.bankForm.controls.currencyId.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_94, _toDisplayString(_ctx.bankForm.controls.currencyId.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_95, [
                    _createVNode("div", _hoisted_96, [
                      _hoisted_97,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "recipientFullName",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.bankForm.props.recipientFullName = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.bankForm.props.recipientFullName]
                      ]),
                      (_ctx.bankForm.controls.recipientFullName.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_98, _toDisplayString(_ctx.bankForm.controls.recipientFullName.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_99, [
                    _createVNode("div", _hoisted_100, [
                      _hoisted_101,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        id: "bankName",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.bankForm.props.bankName = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.bankForm.props.bankName]
                      ]),
                      (_ctx.bankForm.controls.bankName.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_102, _toDisplayString(_ctx.bankForm.controls.bankName.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_103, [
                    _createVNode("div", _hoisted_104, [
                      _hoisted_105,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        id: "bankAddress",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.bankForm.props.bankAddress = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.bankForm.props.bankAddress]
                      ]),
                      (_ctx.bankForm.controls.bankAddress.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_106, _toDisplayString(_ctx.bankForm.controls.bankAddress.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_107, [
                    _createVNode("div", _hoisted_108, [
                      _hoisted_109,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "bankAccountNumber",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.bankForm.props.bankAccountNumber = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.bankForm.props.bankAccountNumber]
                      ]),
                      (_ctx.bankForm.controls.bankAccountNumber.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_110, _toDisplayString(_ctx.bankForm.controls.bankAccountNumber.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_111, [
                    _createVNode("div", _hoisted_112, [
                      _hoisted_113,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "postalCode",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.bankForm.props.postalCode = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.bankForm.props.postalCode]
                      ]),
                      (_ctx.bankForm.controls.postalCode.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_114, _toDisplayString(_ctx.bankForm.controls.postalCode.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_115, [
                    _createVNode("div", _hoisted_116, [
                      _hoisted_117,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "city",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.bankForm.props.city = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.bankForm.props.city]
                      ]),
                      (_ctx.bankForm.controls.city.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_118, _toDisplayString(_ctx.bankForm.controls.city.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_119, [
                    _createVNode("div", _hoisted_120, [
                      _hoisted_121,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "province",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.bankForm.props.province = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.bankForm.props.province]
                      ]),
                      (_ctx.bankForm.controls.province.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_122, _toDisplayString(_ctx.bankForm.controls.province.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_123, [
                    _createVNode("div", _hoisted_124, [
                      _hoisted_125,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "country",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.bankForm.props.country = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.bankForm.props.country]
                      ]),
                      (_ctx.bankForm.controls.country.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_126, _toDisplayString(_ctx.bankForm.controls.country.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_127, [
                    _createVNode("div", _hoisted_128, [
                      _hoisted_129,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "swiftOrBic",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.bankForm.props.swiftOrBic = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.bankForm.props.swiftOrBic]
                      ]),
                      (_ctx.bankForm.controls.swiftOrBic.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_130, _toDisplayString(_ctx.bankForm.controls.swiftOrBic.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_131, [
                    _createVNode("div", _hoisted_132, [
                      _hoisted_133,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "transitNumber",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.bankForm.props.transitNumber = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.bankForm.props.transitNumber]
                      ]),
                      (_ctx.bankForm.controls.transitNumber.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_134, _toDisplayString(_ctx.bankForm.controls.transitNumber.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_135, [
                    _createVNode("div", _hoisted_136, [
                      _hoisted_137,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "institutionNumber",
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.bankForm.props.institutionNumber = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.bankForm.props.institutionNumber]
                      ]),
                      (_ctx.bankForm.controls.institutionNumber.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_138, _toDisplayString(_ctx.bankForm.controls.institutionNumber.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _hoisted_139,
                  _createVNode("div", _hoisted_140, [
                    _createVNode("div", _hoisted_141, [
                      _hoisted_142,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "accountName",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.bankForm.props.accountName = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.bankForm.props.accountName]
                      ]),
                      (_ctx.bankForm.controls.accountName.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_143, _toDisplayString(_ctx.bankForm.controls.accountName.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_144, [
                    _createVNode("div", _hoisted_145, [
                      _hoisted_146,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "phoneNumber",
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.bankForm.props.phoneNumber = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.bankForm.props.phoneNumber]
                      ]),
                      (_ctx.bankForm.controls.phoneNumber.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_147, _toDisplayString(_ctx.bankForm.controls.phoneNumber.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_148, [
                    _createVNode("div", _hoisted_149, [
                      _hoisted_150,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "legalAddressAccountHolder",
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.bankForm.props.legalAddressAccountHolder = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.bankForm.props.legalAddressAccountHolder]
                      ]),
                      _hoisted_151,
                      (_ctx.bankForm.controls.legalAddressAccountHolder.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_152, _toDisplayString(_ctx.bankForm.controls.legalAddressAccountHolder.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isCrypto)
              ? (_openBlock(), _createBlock("div", _hoisted_153, [
                  _createVNode("div", _hoisted_154, [
                    _createVNode("div", _hoisted_155, [
                      _hoisted_156,
                      _withDirectives(_createVNode("select", {
                        id: "currencyId",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.cryptoForm.props.currencyId = $event))
                      }, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cryptosAssets, (c) => {
                          return (_openBlock(), _createBlock("option", {
                            key: c.id,
                            value: c.id
                          }, _toDisplayString(c.id) + " " + _toDisplayString(c.description), 9, ["value"]))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.cryptoForm.props.currencyId]
                      ]),
                      (_ctx.cryptoForm.controls.currencyId.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_157, _toDisplayString(_ctx.cryptoForm.controls.currencyId.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_158, [
                    _createVNode("div", _hoisted_159, [
                      _hoisted_160,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "cryptoAddress",
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.cryptoForm.props.cryptoAddress = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.cryptoForm.props.cryptoAddress]
                      ]),
                      (_ctx.cryptoForm.controls.cryptoAddress.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_161, _toDisplayString(_ctx.cryptoForm.controls.cryptoAddress.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_162, [
                    _createVNode("div", _hoisted_163, [
                      _hoisted_164,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "accountName",
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.cryptoForm.props.accountName = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.cryptoForm.props.accountName]
                      ]),
                      (_ctx.cryptoForm.controls.accountName.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_165, _toDisplayString(_ctx.cryptoForm.controls.accountName.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_166, [
              _createVNode("div", _hoisted_167, [
                _createVNode("button", {
                  onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args))),
                  class: "btn btn-sat-street text-white"
                }, " Save ")
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ])
    ])
  ]))
}